import env from './app-env.js';

export const isProductionEnvironment = env.env === 'production';

export const SENTRY_DSN = env.sentry.dsn;
export const SENTRY_ENV = env.sentry.environment;

export const PUBLIC_BUCKET = env.s3.publicBucket;

// The Social+ network daily session posts are published to. Fixed per environment -
// admins see it but cannot change it.
export const DAILY_SESSION_NETWORK_ID: string = env.socialPlus?.dailySessionNetworkId || '';
export const DAILY_SESSION_NETWORK_NAME: string = env.socialPlus?.dailySessionNetworkName || '';

export const LOCAL_STORAGE_KEYS = {
  isLoggedIn: 'isLoggedIn',
};

export const USER_LINKS = {
  firestore: (userId: string | undefined) => {
    if (!userId || userId?.length === 0) {
      return undefined;
    }
    return `https://console.firebase.google.com/u/0/project/${env.firebaseConfig.projectId}/firestore/data/~2Fprofiles~2F${userId}`;
  },
  customerIo: (userId: string | undefined) => {
    if (!userId || userId?.length === 0) {
      return undefined;
    }
    return `https://fly.customer.io/workspaces/${env.customerIo.workspaceId}/journeys/people/${userId}`;
  },
  mixpanel: (userId: string | undefined) => {
    if (!userId || userId?.length === 0) {
      return undefined;
    }
    return `https://mixpanel.com/project/${env.mixpanel.projectId}/view/${env.mixpanel.viewId}/app/profile#distinct_id=${userId}`;
  },
  revenueCat: (userId: string | undefined) => {
    if (!userId || userId?.length === 0) {
      return undefined;
    }
    return `https://app.revenuecat.com/customers/${env.revenueCat.projectId}/${userId}`;
  },
};

export const PURCHASE_ID_PREFIX = {
  contentGroup: 'com.alux.content-group.',
};

export const TRANSACTION_STATUS = ['started', 'pending', 'cancelled', 'error', 'success', 'redeemed'];
export const S3_BUCKET_NAMES = {
  public: env.s3.assetBuckets.imagesBucket,
  private: env.s3.assetBuckets.mediaBucket,
};
export const REGION = env.s3.assetBuckets.region;
export const ACCESS_KEY = env.s3.assetBuckets.accessKey;
export const SECRET_ACCESS_KEY = env.s3.assetBuckets.secretAccessKey;
